module.exports = __webpack_public_path__ + "img/pasture_andropogon_high.27a1cb99.webp";